import React, { useEffect, useRef, useState } from "react";
import {
  DivSelectBox,
  DivSelectInBox,
  InnerDiv,
  SelectOption,
  SelectOptionBox,
} from "./ReceiptStyle";
import chevronDown from "../../../resources/images/nftf/chevron-down.svg";

const InnerDivCpnt = (props) => {
  const {
    placeHolder,
    options,
    viewData,
    setData,
    cpmtTarget,
    openTarget,
    setOpenTarget,
    handleDialog,
  } = props;
  const [viewYn, setViewYn] = useState(cpmtTarget === openTarget ? true : false);

  const widthRef = useRef(null);

  useEffect(() => {
    if (openTarget === cpmtTarget) {
      setViewYn(true);
    } else {
      setViewYn(false);
    }
  }, [openTarget]);

  const chechReceiptStatus = (receiptType) => {
    switch (receiptType) {
      case "0":
        return { viewYn: "Y", text: "" };
      case "1":
        return { viewYn: "Y", text: "진료 전" };
      case "2":
        return { viewYn: "Y", text: "마감" };
      case "9":
        return { viewYn: "Y", text: "휴진" };
    }
  };

  const openLayerErrMsg = () => {
    switch (props.placeHolder) {
      case "시간":
        return "진료 가능한 시간이 없습니다";
      case "분":
        return "시간을 먼저 선택하세요";
    }
  };

  return (
    <InnerDiv>
      <DivSelectInBox
        ref={widthRef}
        onClick={(e) => {
          if (options != "") {
            setOpenTarget(cpmtTarget);
            setViewYn(!viewYn);
          } else {
            handleDialog("", openLayerErrMsg(), "");
            // handleDialog("", "시간을 먼저 선택하세요", "");
          }
        }}
      >
        <DivSelectBox defaultYn={viewData ? false : true} viewYn={viewYn}>
          {viewData ? viewData.view : placeHolder}
          <img src={chevronDown} />
        </DivSelectBox>
      </DivSelectInBox>

      <SelectOptionBox
        className="cstmSelect"
        viewYn={viewYn}
        style={{ width: widthRef.current?.offsetWidth }}
      >
        {options &&
          options.map((m, i) =>
            (m.startHour === "0000" && m.endHour === "0000") ||
            m.view.split(" ")[1] === "(마감)" ||
            m.view.split(" ")[1] === "(휴진)" ? (
              <SelectOption
                key={"options" + i}
                style={{ color: "#CCCCCC", display: "flex", gap: "4px" }}
              >
                <div>{m.view.split(" ")[0]}</div>
                <div
                  style={{
                    background: "#f0f0f0",
                    borderRadius: "4px",
                    padding: "3px 4px",
                    fontWeight: "600",
                  }}
                >
                  {m.view.split(" ")[1].substring(1, 3)}
                </div>
              </SelectOption>
            ) : (
              <SelectOption
                onClick={() => {
                  setData(m);
                  setViewYn(!viewYn);

                  cpmtTarget === "HOUR" && setOpenTarget("MIN");
                }}
                key={"options" + i}
              >
                {m.view}
              </SelectOption>
            )
          )}
      </SelectOptionBox>
    </InnerDiv>
  );
};

export default React.memo(InnerDivCpnt);
